/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from 'src/app/services/infra/user/user.service';

@Injectable({
  providedIn: 'root',
})
/**
 * A guard to verify we loaded all of the user permissions,
 * So we can show the user only things his allowed to see
 */
export class UserLoaderGuard {
  constructor(private readonly _userService: UserService) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._userService.canLoadApp();
  }
}
